module.exports = __webpack_public_path__ + "img/oup.dc4b315b.png";